import React from 'react';
import css from './PrivacyPolicyLink.css';

function PrivacyPolicyLink() {
  return (
    <a 
      className={css['link']} 
      href="https://eab.com/privacy-policy-2"
      target="_blank"
      rel="noopener noreferrer">
      Privacy Policy
    </a>
  );
}

export default PrivacyPolicyLink;
